import React from 'react';
import { SeniorCyber2026 } from '../views';


const BlogNewsroomPage = () => {

return <SeniorCyber2026 />
};

export default BlogNewsroomPage;